export const NAV_LINKS = [
  { label: "About", target: "/about", type: "route" },
  { label: "Ecosystem", target: "ecosystem", type: "scroll" },
  { label: "Solutions", target: "solutions", type: "scroll" },
  { label: "Technology", target: "/technology", type: "route" },
  { label: "Contact", target: "/contact", type: "route" },
];

export const FOUNDERS = [
  {
    id: "ernesto",
    name: "Dr. Ernesto Couso, Ph.D.",
    title: "Co-Founder & CTO",
    photo: "/assets/founder-ernesto.png",
    bio: "30+ years across software, cloud infrastructure, systems architecture, data, cybersecurity and AI. Leads platform architecture, product strategy and commercialization technology.",
    expertise: ["Cloud & Systems Architecture", "AI & Data", "Cybersecurity", "Product Strategy"],
    linkedin: "https://linkedin.com/in/ernestocouso",
  },
  {
    id: "andy",
    name: "Dr. Andy R. Manzano, MD",
    title: "Clinical Co-Founder & CEO",
    photo: "/assets/founder-andy.png",
    bio: "Internationally experienced physician with 14+ years in the U.S. as partner and owner of multi-clinic healthcare companies spanning primary care, physical rehabilitation and wound care. Provides direct multi-clinic operating experience and pilot access.",
    expertise: ["Multi-Clinic Operations", "Primary & Rehab Care", "Wound Care", "Clinical Strategy"],
    linkedin: "",
  },
];

export const ABOUT_STRATEGY = [
  { icon: "Boxes", title: "Unified Platform", text: "One connected platform across every division — a single source of truth for care, data and operations." },
  { icon: "Brain", title: "AI-First Operations", text: "Automation and intelligence embedded across workflows to lower cost and raise the quality of care." },
  { icon: "Share2", title: "Interoperability", text: "FHIR / HL7 / API-native connectivity that plugs cleanly into any health system or partner." },
  { icon: "TrendingUp", title: "Scalable Growth", text: "A repeatable model built to expand division-by-division and market-by-market, nationwide." },
];

export const ABOUT_ROADMAP = [
  { phase: "01", title: "Foundation", text: "Launch unified EHR, revenue-cycle and core infrastructure across founding clinics." },
  { phase: "02", title: "Integration", text: "Connect behavioral health, home care and MedTech onto one shared data backbone." },
  { phase: "03", title: "Intelligence", text: "Deploy AI-assisted operations, remote monitoring and predictive analytics at scale." },
  { phase: "04", title: "Expansion", text: "Scale the PUMS ecosystem nationwide through partnerships and new markets." },
];

export const INVESTOR_HIGHLIGHTS = [
  { value: "$4.5T", label: "U.S. healthcare market" },
  { value: "6", label: "Specialized divisions" },
  { value: "44+", label: "Years combined leadership" },
  { value: "1", label: "Connected platform" },
];

export const INVESTOR_POINTS = [
  { icon: "LineChart", title: "Large, Durable Market", text: "Healthcare's shift toward connected, value-based care is a multi-decade tailwind." },
  { icon: "Boxes", title: "Platform, Not a Point Solution", text: "Multiple revenue lines across divisions, all on shared, reusable infrastructure." },
  { icon: "Stethoscope", title: "Operator-Founded", text: "Led by a practicing physician-operator and a veteran technology architect." },
  { icon: "ShieldCheck", title: "Defensible & Compliant", text: "HIPAA-ready, interoperable and engineered for enterprise-grade trust." },
];

export const ABOUT_VALUES = [
  { icon: "Heart", title: "Compassion", text: "People first — in every decision and line of care." },
  { icon: "Cpu", title: "Innovation", text: "Technology that meaningfully improves outcomes." },
  { icon: "ShieldCheck", title: "Integrity", text: "Secure, compliant and trustworthy by design." },
  { icon: "Users", title: "Collaboration", text: "One connected team across every division." },
  { icon: "TrendingUp", title: "Excellence", text: "Relentless focus on quality and results." },
  { icon: "Activity", title: "Impact", text: "Healthier people and stronger communities." },
];

export const ABOUT_STATS = [
  { value: "30+", label: "Years in Technology" },
  { value: "14+", label: "Years U.S. Clinical" },
  { value: "6", label: "Specialized Divisions" },
  { value: "1", label: "Unified Vision" },
];

export const WHY_FEATURES = [
  { icon: "Brain", title: "AI-Assisted Operations", text: "Intelligent automation to reduce administrative burden and improve outcomes." },
  { icon: "Share2", title: "Interoperability (FHIR / HL7 / APIs)", text: "Seamless connectivity across systems, partners and care settings." },
  { icon: "ShieldCheck", title: "Secure & Compliant", text: "HIPAA-ready, enterprise-grade security and regulatory compliance." },
  { icon: "BarChart3", title: "Workflow & Revenue Efficiency", text: "Streamlined operations for stronger financial performance." },
  { icon: "Heart", title: "Patient-Centered Care", text: "Better experiences, better outcomes, brighter futures." },
  { icon: "TrendingUp", title: "Scalable Growth", text: "A unified platform built to scale nationwide and beyond." },
];

export const ECOSYSTEM = [
  {
    key: "homecare",
    logo: "/assets/logo-eco-homecare.png",
    title: "Home Health, Coordination & Remote Monitoring",
    phrase: "Compassionate care. Connected everywhere.",
    whatsInside: "Skilled nursing, remote monitoring & care coordination.",
    cta: "Learn More",
    featured: false,
  },
  {
    key: "bh",
    logo: "/assets/logo-eco-bh.png",
    title: "Pediatric Behavioral Health",
    phrase: "Brighter minds. Brighter futures.",
    whatsInside: "Therapy, telehealth & family care navigation for kids.",
    cta: "Learn More",
    featured: false,
  },
  {
    key: "clinic",
    logo: "/assets/logo-eco-clinic.png",
    badge: "Signature App",
    title: "Multi-Specialty Clinical Care",
    phrase: "Comprehensive care, close to home.",
    whatsInside: "Primary care, rehab, wound care & multi-specialty clinics.",
    cta: "Explore ProactiveClinic+",
    featured: true,
  },
  {
    key: "medtech",
    logo: "/assets/logo-eco-medtech.png",
    title: "Devices, Integration & Clinical Technology",
    phrase: "Innovation that moves care forward.",
    whatsInside: "Connected devices, integrations & clinical technology.",
    cta: "Learn More",
    featured: false,
  },
  {
    key: "core",
    logo: "/assets/logo-eco-core.png",
    title: "AI, Cloud, Data & Digital Transformation",
    phrase: "Smarter infrastructure for a healthier tomorrow.",
    whatsInside: "AI, secure cloud, data platforms & analytics.",
    cta: "Learn More",
    featured: false,
  },
];

export const HERO_SLIDES = [
  {
    img: "/assets/hero-slide-1.png",
    eyebrow: "Proactive UMS Corporate",
    title: ["THE PUMS", "ECOSYSTEM"],
    subtitle: "One intelligent healthcare corporation connecting care, technology, and operations.",
    text: "Behavioral health, home care, clinics, MedTech and AI — unified under one scalable corporate platform.",
    cta: { label: "Explore the Ecosystem", type: "scroll", target: "ecosystem" },
  },
  {
    img: "/assets/hero-slide-2.png",
    eyebrow: "ProactiveBH+ · Pediatric Behavioral Health",
    title: ["BRIGHTER MINDS,", "BRIGHTER FUTURES"],
    subtitle: "Compassionate, family-centered behavioral health for every child.",
    text: "Evidence-based pediatric therapy, telehealth and care navigation that meet children where they are.",
    cta: { label: "Explore ProactiveBH+", type: "route", target: "/division/bh" },
  },
  {
    img: "/assets/hero-slide-3.png",
    eyebrow: "ProactiveHomeCare+ · Home Health & Remote Monitoring",
    title: ["CARE THAT", "COMES HOME"],
    subtitle: "Connected monitoring and compassionate care, wherever life happens.",
    text: "Skilled clinicians and 24/7 remote monitoring keep patients safe, independent and connected.",
    cta: { label: "Explore ProactiveHomeCare+", type: "route", target: "/division/homecare" },
  },
  {
    img: "/assets/hero-slide-4.png",
    eyebrow: "ProactiveCore+ · AI, Cloud & Data",
    title: ["INTELLIGENCE THAT", "POWERS CARE"],
    subtitle: "Secure cloud, AI and analytics driving smarter healthcare decisions.",
    text: "The intelligent infrastructure unifying every division of the PUMS ecosystem.",
    cta: { label: "Explore ProactiveCore+", type: "route", target: "/division/core" },
  },
];

export const SOLUTIONS = [
  { key: "ehr", icon: "FileText", title: "Unified EHR / EMR", text: "A connected record for a more complete picture of care." },
  { key: "rcm", icon: "Settings", title: "Practice & RCM", text: "Streamlined workflows. Healthier revenue." },
  { key: "integration", icon: "Workflow", title: "Enterprise Integration", text: "Connect systems, people and data." },
  { key: "portals", icon: "Users", title: "Patient / Provider / Employer Portals", text: "Access. Engagement. Better outcomes." },
  { key: "telehealth", icon: "MonitorSmartphone", title: "Telehealth & Remote Care", text: "Care without boundaries." },
  { key: "analytics", icon: "BarChart3", title: "Analytics & Automation", text: "Turn data into healthier decisions." },
];

export const COMMUNITY_TAGS = [
  { icon: "Heart", title: "Patients", sub: "& Families" },
  { icon: "Activity", title: "Providers", sub: "& Care Teams" },
  { icon: "Briefcase", title: "Employers", sub: "& Health Plans" },
  { icon: "Users", title: "Communities", sub: "& Populations" },
];

export const MAP_PINS = [
  { x: 20, y: 40 }, { x: 30, y: 62 }, { x: 44, y: 30 }, { x: 52, y: 55 },
  { x: 60, y: 42 }, { x: 68, y: 66 }, { x: 74, y: 34 }, { x: 82, y: 50 },
  { x: 38, y: 48 }, { x: 26, y: 28 },
];
